<template>
    <div class="proto_wrap" :class="{ safe_padding: paddingShow && system === 'ios' }" ref="protoWrapper">
        <slide-bar
            :pageShare="false"
            :show="slideBar"
            @close="closeSlideBar"
            @share="shareShow = true"
            :homeId="homeId"
        ></slide-bar>
        <v-touch
            class="zone"
            @press="showSlideBar(true, 'press')"
            @doubletap="showSlideBar(true, 'doubletap')"
            @tap="showSlideBar(false)"
        >
            <div class="proto_touch_zone">
                <proto
                    ref="proto"
                    :pageShare="false"
                    :hotspots="hotspots"
                    :image-src="imageSrc"
                    :imgHeight="imgHeight"
                    :layoutData="layoutData"
                    :showHead="system === 'ios' ? showHead : true"
                    :showFoot="system === 'ios' ? showFoot : true"
                ></proto>
            </div>
            <div @touchstart="hideGuide" v-show="protoGuide">
                <div class="proto_guide" :class="{ hide: !guide }"></div>
            </div>
        </v-touch>
        <v-touch>
            <share :show="shareShow" @close="shareShow = false" :protoData="protoData" type="proto" :homeId="homeId" />
        </v-touch>
    </div>
</template>

<script>
import slideBar from "@/components/layout/SlideBar"
import Proto from "./components/ProtoItem"
import share from "@/components/common/Sharing"
export default {
    components: {
        slideBar,
        Proto,
        share
    },
    data() {
        return {
            slideBar: false,
            guide: true,
            hotspots: [],
            layoutData: null,
            protoGuide: null,
            imageSrc: "",
            imgHeight: 0,
            shareShow: false,
            scrollTop: 0,
            scrollHeight: 0,
            protoData: {
                id: "",
                team_id: "",
                pid: "",
                img: "",
                name: ""
            },
            homeId: ""
        }
    },
    computed: {
        direction() {
            return window.vm.device.direction
        },
        system() {
            return window.system
        },
        imageId() {
            return this.$route.query.image_id
        },
        paddingShow() {
            return this.imgHeight < this.$root.device.size.height
        },
        showHead() {
            if (this.scrollTop < 0) {
                return false
            } else {
                return true
            }
        },
        showFoot() {
            if (this.scrollHeight && this.scrollHeight < this.scrollTop + this.$root.device.size.height) {
                return false
            } else {
                return true
            }
        }
    },
    watch: {
        $route() {
            this.getImage()
        }
    },
    created() {
        this.judgeGuide()
    },
    updated() {},
    mounted() {
        try {
            this.$refs.protoWrapper.addEventListener("scroll", this.judgeHeadFoot)
            this.getImage()
            if (window.isWebview) {
                screen.orientation.unlock()
                StatusBar.hide()
            }
        }
        catch (e) {
            // alert(e.toString());
        }
    },
    beforeDestroy() {
        if (window.isWebview) {
            screen.orientation.lock("portrait")
            StatusBar.show()
        }
        this.$refs.protoWrapper.removeEventListener("scroll", this.judgeHeadFoot)
    },
    methods: {
        //判断是否显示固定内容
        judgeHeadFoot() {
            this.scrollTop = this.$refs.protoWrapper.scrollTop
            this.scrollHeight = this.$refs.protoWrapper.scrollHeight
        },
        getImgHeight() {
            document.querySelector("#proto_img").addEventListener("load", () => {
                this.imgHeight = document.querySelector("#proto_img").offsetHeight
            })
        },
        //判断引导图
        judgeGuide() {
            this.protoGuide = localStorage.protoGuide
        },
        showSlideBar(value, type) {
            this.slideBar = value
            MtaH5.clickStat("menu_trigger", { [type]: "true" })
        },
        closeSlideBar() {
            this.slideBar = false
        },
        hideGuide() {
            localStorage.protoGuide = ""
            this.guide = false
        },
        //请求当前图片信息
        async getImage() {
            let teamId = localStorage.teamId
            let imageId = this.imageId
            let pid = this.$route.query.project_id
            let res = await API.image.getImageInfo(teamId, imageId)
            let protoRes = await API.image.getProtoHome(teamId, pid)
            if (protoRes.data.result && protoRes.data.result.home_id) {
                this.homeId = protoRes.data.result.home_id
            }

            if (res) {
                let data = res.data.result
                this.hotspots = []

                data.positions.forEach(ele => {
                    if (ele.next_image) {
                        if (ele.p_h > 1 || ele.p_w > 1 || ele.p_x > 1 || ele.p_y > 1) {
                            ele.p_h = (ele.p_h / ele.height) * 100 + "%"
                            ele.p_w = (ele.p_h / ele.width) * 100 + "%"
                            ele.p_x = (ele.p_h / ele.width) * 100 + "%"
                            ele.p_y = (ele.p_h / ele.height) * 100 + "%"
                        }
                        this.hotspots.push(ele)
                    }
                })

                this.imageSrc = window.mtd.handleImg(data.url, {
                    ali: this.$root.isSupportWebp ? "?x-oss-process=image/format,webp" : "",
                    qiniu: ""
                })

                if (
                    data.versions &&
                    data.versions.length > 0 &&
                    data.versions[0].version_layout_data &&
                    JSON.parse(data.versions[0].version_layout_data).scrollInfo &&
                    (JSON.parse(data.versions[0].version_layout_data).scrollInfo.topOffset ||
                        JSON.parse(data.versions[0].version_layout_data).scrollInfo.bottomOffset)
                ) {
                    this.layoutData = JSON.parse(data.versions[0].version_layout_data)
                } else {
                    if (data.layout_data) {
                        this.layoutData = JSON.parse(data.layout_data)
                    } else {
                        this.layoutData = {}
                    }
                }
                this.protoData.id = data.share_id
                this.protoData.name = data.name
                this.protoData.team_id = localStorage.teamId
                this.protoData.pid = this.$route.query.project_id
                this.protoData.img = data.url

                this.getImgHeight()
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.proto_wrap {
    height: 100vh;
    width: 100%;
    overflow-y: auto;
    position: absolute;
    left: 0;
    top: 0;
    box-sizing: border-box;
    background: black;
    &.safe_padding {
        padding-top: constant(safe-area-inset-top);
        padding-top: env(safe-area-inset-top);
        padding-bottom: constant(safe-area-inset-bottom);
        padding-bottom: env(safe-area-inset-bottom);
    }
    .zone {
        height: 100%;
    }
    .proto_touch_zone {
        min-height: 100%;
        overflow: auto;
    }
    .proto_guide {
        z-index: 1111;
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.8) url("~@/assets/imgs/guide_proto.png") center center / 50% no-repeat;
        transition: all ease 300ms;

        &.hide {
            opacity: 0;
            z-index: -1;
        }
    }
}
</style>
